(function () {
  'use strict';

  function fmt(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric' }); }
  function addDays(n) { return new Date(Date.now() + n * 86400000); }
  function range(from, to) {
    return from === to ? fmt(addDays(from)) : fmt(addDays(from)) + ' \u2013 ' + fmt(addDays(to));
  }
  function num(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function setup(root) {
    if (!root || root.dataset.ready) { return; }
    root.dataset.ready = '1';

    var readyFrom = num(root.dataset.readyFrom, 1);
    var readyTo = Math.max(readyFrom, num(root.dataset.readyTo, 2));
    var deliveryFrom = num(root.dataset.deliveryFrom, 3);
    var deliveryTo = Math.max(deliveryFrom, num(root.dataset.deliveryTo, 4));

    root.querySelector("[data-step='1'] .track-date").textContent = fmt(addDays(0));
    root.querySelector("[data-step='2'] .track-date").textContent = range(readyFrom, readyTo);
    root.querySelector("[data-step='3'] .track-date").textContent = range(deliveryFrom, deliveryTo);

    var steps = root.querySelectorAll('.track-step');
    var f1 = root.querySelector('.f1');
    var f2 = root.querySelector('.f2');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var played = false;

    function play() {
      if (played) { return; }
      played = true;
      if (reduce) {
        for (var i = 0; i < steps.length; i++) { steps[i].classList.add('on'); }
        f1.style.width = '100%';
        f2.style.width = '100%';
        return;
      }
      setTimeout(function () { steps[0].classList.add('on'); }, 150);
      setTimeout(function () { f1.style.width = '100%'; }, 600);
      setTimeout(function () { steps[1].classList.add('on'); }, 1400);
      setTimeout(function () { f2.style.width = '100%'; }, 1850);
      setTimeout(function () { steps[2].classList.add('on'); }, 2650);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { play(); io.disconnect(); }
      }, { threshold: 0.35 });
      io.observe(root);
    } else {
      play();
    }
  }

  function init() {
    var all = document.querySelectorAll('.order-tracker');
    for (var i = 0; i < all.length; i++) { setup(all[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
